import { cn } from "@/lib/utils";
import { CheckCircle } from "lucide-react";

interface ProgressStepsProps {
  currentStep: number;
}

export function ProgressSteps({ currentStep }: ProgressStepsProps) {
  const steps = [
    { number: 1, label: 'Account Details', completed: currentStep > 1 },
    { number: 2, label: 'Verification', completed: currentStep > 2 },
    { number: 3, label: 'Complete Profile', completed: false }
  ];

  return (
    <div className="mb-8">
      <div className="text-center mb-4">
        <p className="text-sm font-medium text-primary">Step {currentStep} of {steps.length}</p>
        <h3 className="text-lg text-muted-foreground mt-1">{steps[currentStep - 1]?.label}</h3>
      </div>

      <div className="flex items-center justify-center gap-2">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center">
            <div
              className={cn(
                "w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all",
          currentStep === step.number
            ? "bg-primary text-primary-foreground ring-4 ring-primary/20"
            : step.completed
            ? "bg-success text-success-foreground"
            : "bg-muted text-muted-foreground"
              )}
            >
              {step.completed ? <CheckCircle className="h-5 w-5" /> : step.number}
            </div>

            {index < steps.length - 1 && (
              <div className={cn("w-16 h-1 mx-2 transition-all", step.completed ? "bg-success" : "bg-muted")} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
